import { Image } from '@cian/ui-kit';

import { type FC, useCallback } from 'react';

import styles from './styles.css';

interface IBannerProps {
  image: string;
  hitUrl: string;
  disclaimer?: string;
  onBannerClick: () => void;
}

export const Banner: FC<IBannerProps> = ({ disclaimer, image, hitUrl, onBannerClick }) => {
  const handleClick = useCallback((): void => {
    onBannerClick();
  }, [onBannerClick]);

  return (
    <a
      className={styles['container']}
      data-testid="banner"
      href={hitUrl}
      rel="noopener noreferrer"
      target="_blank"
      onClick={handleClick}
    >
      <div className={styles['content']}>
        <Image borderRadius={0} height={220} src={image} width={1100} />
      </div>
      {disclaimer && (
        <div className={styles['disclaimer']} data-testid="banner-disclaimer">
          {disclaimer}
        </div>
      )}
    </a>
  );
};
